import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AuthActions } from '../../store';
import { Footer } from '../Footer/Footer';
import './ResetPassword.css';

const logo = require('../Login/assets/login-logo.png');

/* eslint-disable camelcase */

export class ResetPassword extends Component {
  state = {
    newPassword1: '',
    newPassword2: '',
  };

  componentWillUnmount() {
    this.props.clearResetPasswordError();
  }

  handleFieldChange(e) {
    const { name, value } = e.target;

    this.setState((state) => ({
      ...state,
      [name]: value,
    }));
  }

  resetPassword(e) {
    e.preventDefault();
    const { newPassword1, newPassword2 } = this.state;
    const user_hash = this.props.match.params.hash;
    const { token } = this.props.match.params;

    if (newPassword1 && newPassword2) {
      if (newPassword1 === newPassword2) {
        this.props.resetPassword(newPassword1, newPassword2, user_hash, token);
      } else {
        this.props.setResetPasswordError('Passwords do not match.');
      }
    } else {
      this.props.setResetPasswordError('Password cannot be blank.');
    }
  }

  renderResetPasswordSuccess() {
    const { resetPasswordMessage } = this.props;
    return (
      <div className="reset-password-fields">
        <div className="reset-password__title">Success!</div>
        <div className="reset-password__text">{resetPasswordMessage}</div>
        <Link to="/login" className="reset-password__login">
          &lt; Back to login
        </Link>
      </div>
    );
  }

  renderResetPasswordForm() {
    const { newPassword1, newPassword2 } = this.state;
    const { resetPasswordError } = this.props;

    // set error message visibility depending on state
    let resetMessageClasses = 'reset-password__message';
    resetMessageClasses += this.props.resetPasswordError ? ' reset-password__message--error' : '';

    return (
      <div className="reset-password-fields">
        <div className="reset-password__title">Enter your new password below.</div>
        <form onSubmit={(e) => this.resetPassword(e)} className="reset-password-form">
          <input
            className="reset-password__input"
            value={newPassword1}
            onChange={(e) => this.handleFieldChange(e)}
            type="password"
            id="newPassword1"
            name="newPassword1"
            placeholder="Enter your new password"
          />
          <input
            className="reset-password__input"
            value={newPassword2}
            onChange={(e) => this.handleFieldChange(e)}
            type="password"
            id="newPassword2"
            name="newPassword2"
            placeholder="Re-enter your new password"
          />
          <div className={resetMessageClasses}>{resetPasswordError}</div>
          <button type="submit" className="reset-password__button">
            Reset Password
          </button>
        </form>
        <Link to="/login" className="reset-password__login">
          &lt; Back to login
        </Link>
      </div>
    );
  }

  render() {
    const { resetPasswordMessage, resetPasswordError } = this.props;
    return (
      <div className="reset-password">
        <div className="reset-password-content">
          <div className="reset-password-logo-wrapper">
            <img className="reset-password__logo" src={logo} alt="Parity" />
          </div>
          <div className="reset-password-fields-wrapper">
            {resetPasswordMessage && !resetPasswordError
              ? this.renderResetPasswordSuccess()
              : this.renderResetPasswordForm()}
          </div>
        </div>
        <Footer light />
      </div>
    );
  }
}

ResetPassword.propTypes = {
  resetPasswordMessage: PropTypes.string,
  resetPasswordError: PropTypes.string,
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
    isExact: PropTypes.bool,
    params: PropTypes.shape({
      hash: PropTypes.string,
      token: PropTypes.string,
    }),
  }).isRequired,
  resetPassword: PropTypes.func.isRequired,
  setResetPasswordError: PropTypes.func.isRequired,
  clearResetPasswordError: PropTypes.func.isRequired,
};

ResetPassword.defaultProps = {
  resetPasswordMessage: undefined,
  resetPasswordError: undefined,
};

export function mapStateToProps(state) {
  return {
    resetPasswordMessage: state.passwordReducer.message,
    resetPasswordError: state.passwordReducer.error,
  };
}

const mapDispatchToProps = {
  resetPassword: AuthActions.resetPassword,
  setResetPasswordError: AuthActions.setResetPasswordError,
  clearResetPasswordError: AuthActions.clearResetPasswordError,
};

const ConnectedResetPassword = connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
export { ConnectedResetPassword };
